import React from 'react'
import styled from 'styled-components'
import tw from 'twin.macro'
import { RichText } from 'prismic-reactjs'

export default function VideoWithText({ slice }) {
  const doc = slice.primary
  return (
    <Root>
      <iframe
        title='Famiglia Santoni'
        style={{ marginBottom: '3rem' }}
        src={doc.video.embed_url}
        width="100%"
        height="360"
        frameBorder="0"
        allow="autoplay; fullscreen"
        allowFullScreen>
      </iframe>
      <div>
        <RichText render={doc.text} />
      </div>
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${tw`mb-16`}


  & p {
    ${tw`p-2 sm:p-6 md:p-0 mb-3`}
    max-width: 600px;
    font-size: 1rem;
  }
`;
